import React, { useEffect, useState } from 'react'
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from 'react-redux';
import { decryptAndRetrieveData } from './login/encript-decript';
import { contactus } from '../store/reducers';
import { toast } from 'react-toastify';
// import { sendContactUs } from '../redux/actions/other';


function Contact() {
    
    
    const dispatch = useDispatch();
    const initialValue = { 
        first_name: '', 
        last_name: '', 
        // email: user?.email || '', 
        email: '', 
        phone: '', 
        comment: '' 
    };
    
    const [sending, setSending] = useState(false);
    const contactUsSchema = Yup.object().shape({
        email: Yup.string().email("Invalid email address").required("Required"),
        comment: Yup.string().required("Required"),
        phone: Yup.string()
        .test(
            "is-empty-or-valid", // Test name
            "Phone number must be exactly 10 digits", // Error message
            (value) => {
                if (!value || value.length === 0) {
                    return true; // Pass if the field is empty (no validation)
                }
                return /^[0-9]{10}$/.test(value); // Validate if it contains exactly 10 digits
            }
        ),
    });

    const handleSubmit = (values, { resetForm }) => {        
        setSending(true);

        dispatch(contactus(values))
            .then((res) => {
                if (res.meta.requestStatus === "fulfilled"){
                    toast.success(res.payload)
                }
                
                setSending(false);
                resetForm();
            })
            .catch(() => {
                setSending(false);
            });
    };

    return (
        <section className=" d-flex page-section contact_section py-5" style={{ justifyContent: 'center' }}>
            <div className="container1 overflow-hidden">
                <h1 className="m-0 mb-2" style={{fontWeight:'600'}}>Contact Us</h1>
                <p className="m-0 mb-4">If you want to reach out to us, fill out the contact form below. We’ll get back to you as soon as we can! </p>
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="mb-4">
                            <div className="card-body h-auto col-12">

                                <Formik
                                    initialValues={initialValue}
                                    validationSchema={contactUsSchema}
                                    enableReinitialize={true}
                                    onSubmit={handleSubmit}>
                                    {({ errors, touched, isValidating,setFieldValue }) => (
                                        <Form>
                                            <div className='row'>
                                                <div className='col-md-6 col-12'>
                                                    <div className="row mb-6">
                                                        <div className="col">
                                                            <div className="form-outline">
                                                                <label className="form-label" htmlFor="first_name">First name</label>
                                                                <Field id={'first_name'} name="first_name" placeholder="First name" className={`form-control`} />
                                                            </div>
                                                        </div>
                                                        <div className="col">
                                                            <div className="form-outline">
                                                                <label className="form-label" htmlFor="last_name">Last name</label>
                                                                <Field id={'last_name'} name="last_name" placeholder="Last name" className={`form-control`} />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="form-outline mb-3">
                                                        <label className="form-label" htmlFor="email">Login Email</label>
                                                        <Field id={'email'} name="email" placeholder="example@personalgmail.com"
                                                            className={`form-control ${touched.email && errors.email ? "is-invalid" : ""}`} />
                                                    </div>

                                                    <div className="form-outline mb-3">
                                                        <label className="form-label" htmlFor="phone">Phone Number</label>
                                                        <Field
                                                            type='text'  // Change this to 'text' to handle numeric input better across devices
                                                            inputMode='numeric'  // Force numeric keyboard on mobile devices
                                                            name="phone"
                                                            placeholder="Phone Number"
                                                            maxLength={10}
                                                            onChange={(e) => {
                                                                const value = e.target.value.replace(/[^0-9]/g, '');
                                                                if (value.length <= 10) {
                                                                    setFieldValue('phone', value);
                                                                }
                                                            }}
                                                            onInput={(e) => {  // Replace onKeyPress with onInput for better mobile support
                                                                if (['e', '.', '+', '-'].includes(e.data)) {
                                                                    e.preventDefault();  // Prevent special characters from being entered
                                                                }
                                                            }}
                                                            className={`form-control ${touched.phone && errors.phone ? "is-invalid" : ""}`}
                                                        />

                                                        <ErrorMessage
                                                            component="div"
                                                            name="phone"
                                                            className="invalid-feedback"
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-md-6 col-12'>
                                                    <div className="form-outline mb-3">
                                                        <label className="form-label" htmlFor="comment">Message</label>
                                                        <Field id='comment' as="textarea" name="comment" placeholder="Leave your message here" rows="7"
                                                            className={`form-control ${touched.comment && errors.comment ? "is-invalid" : ""}`} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='d-flex' style={{justifyContent:'flex-end'}}>
                                            <button
                                                disabled={sending}
                                                type="submit"
                                                className="btn send_btn d-flex justify-center">
                                                {sending ? 'SENDING...' : 'SEND MESSAGE'}
                                            </button>
                                            </div>

                                        </Form>
                                    )}
                                </Formik>
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-md-6 mb-4">
                        <div className=" mt-4">
                            <iframe src="https://www.google.com/maps/embed/v1/place?key=AIzaSyA0s1a7phLN0iaD6-UE7m4qP-z21pH0eSc&q=Office+of+Planning+%26+Research/@38.5755685,-121.4957269,21z"
                                className="w-100" height="435" allowFullScreen="" loading="lazy" />
                        </div>
                    </div> */}
                </div>
            </div>
        </section>
    )
}

export default Contact
